var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-drawer',{attrs:{"title":_vm.titleMap[_vm.field] || '详情',"visible":_vm.visible,"width":"720"},on:{"close":_vm.closeDrawer}},[_c('a-table',{attrs:{"row-key":"id","columns":_vm.columns,"data-source":_vm.list,"pagination":_vm.pagination,"bordered":""},on:{"change":_vm.handlePageChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }